import {Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {PrenotazioneAppuntamentoService} from "../../services/prenotazione-appuntamento.service";
import {Festivita} from "../../models/festivita";
import {Appuntamento} from "../../models/appuntamento";
import {Employee} from "../../models/employee";
import {FasceOrarie} from "../../models/fasce-orarie";
import {FormBuilder, Validators} from "@angular/forms";
import {JoyrideService} from 'ngx-joyride';
import {zonedTimeToUtc, format} from 'date-fns-tz';
import {
  addMonths, addYears,
  getDate,
  getDaysInMonth,
  getMonth,
  getYear, isAfter, isBefore, isEqual, setDate,
  setMonth,
  setYear,
  startOfMonth,
  subMonths
} from "date-fns";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import { ConfigurazioneGeneraleService } from '../../services/configurazione-generale.service';
import { UserData } from '../../models/user-data';

@Component({
  selector: 'jhi-scelta-data-ora-prenotazione-admin',
  templateUrl: './scelta-data-ora-prenotazione.component.html',
  styleUrls: ['./scelta-data-ora-prenotazione.component.scss']
})
export class SceltaDataOraPrenotazioneComponent extends SubscriptionManager implements OnInit {
  formSceltaOrario = this.fb.group({
    giornoScelto: ['', [Validators.required]],
    orarioInizioScelto: ['', [Validators.required]],
    orarioFineScelto: ['', [Validators.required]]
  });
  selectedLanguage: string = this.translateService.currentLang;
  circleLoading = false;
  skeletonLoading = false;
  calendarLoading = false;
  codiceServizio: string | null = null;
  ufficio: string | null = null;

  listaFestivita!: Festivita[];
  idDipendente!: number;
  datiDipendente!: Employee;
  appuntamento?: Appuntamento;
  fasceOrarie!: FasceOrarie[];

// Data attuale/effettiva
  actualDate = zonedTimeToUtc(new Date(), 'Europe/Rome');
  actualMonth!: string;
  actualMonthDay = getMonth(this.actualDate);
  actualYear!: number;
  actualDayIndex !: number;

  // Valore cardinale del giorno nel Button selezionato
  selectedDate = this.actualDate;
  selectedDay = 0;
  selectedMonth!: number;
  selectedYear!: number;
  selectedTime!: string;

  // Data cercata sul calendario
  todayDate = this.actualDate;
  firstDayOfMonth = this.actualDate;
  firstDayOfNextMonth = this.actualDate;
  weekdays!: string[];
  weekdayName!: string;
  nextMonthFirstName!: string;

  todayDayIndex !: number;
  todayMonth!: string;
  todayYear!: number;
  todayMonthDay!: number;

  daysInMonth!: number;
  daysInNextMonth!: number;
  daysInPrecMonth!: number;

  disablePrecedent = true;
  disableNext = true;

  userData?: UserData;

  protected readonly Array = Array;

  constructor(private joyrideService: JoyrideService, private configurazioneGeneraleService: ConfigurazioneGeneraleService, public route: Router, private activatedRoute: ActivatedRoute, private prenotazioneService: PrenotazioneAppuntamentoService, private fb: FormBuilder, public translateService: TranslateService) {
    super();
  }

  public convertTimeStringToDate(time: string): Date {
    return new Date(2023, 1, 1, parseInt(time.split(':')[0], 10), parseInt(time.split(':')[1], 10))
  }

  get getGiornoScelto(): any {
    return this.formSceltaOrario.controls['giornoScelto']
  };

  get getOrarioInizioScelto(): any {
    return this.formSceltaOrario.controls['orarioInizioScelto']
  };

  get getOrarioFineScelto(): any {
    return this.formSceltaOrario.controls['orarioFineScelto']
  };

  isHoliday(anno: number, mese: number, giorno: number): boolean {
    if (this.listaFestivita != null || undefined) {
      const dateBuilder: Date = zonedTimeToUtc(new Date(anno, mese, giorno), 'Europe/Rome')
      for (const festivita of this.listaFestivita) {
        const dateConv = zonedTimeToUtc(new Date(festivita.dtFestivita), 'Europe/Rome');
        if (
          getYear(dateBuilder) === getYear(dateConv) &&
          getMonth(dateBuilder) === getMonth(dateConv) &&
          getDate(dateBuilder) === getDate(dateConv)
        ) {
          return true;
        }
      }
    }
    return false;
  }


  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.userData = JSON.parse(<string>localStorage.getItem('userData'));
    this.codiceServizio = this.activatedRoute.snapshot.queryParams["servizio"];
    this.ufficio = this.activatedRoute.snapshot.queryParams["ufficio"];
    this.circleLoading = true;
    this.todayMonthDay = getMonth(this.todayDate);

    this.actualYear = getYear(this.todayDate);
    this.actualMonth = format(this.actualDate, 'LLLL');
    this.actualDayIndex = getDate(this.actualDate);

    this.firstDayOfMonth = startOfMonth(this.todayDate);
    this.firstDayOfNextMonth = startOfMonth(addMonths(this.todayDate, 1));

    this.weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    this.weekdayName = format(this.firstDayOfMonth, 'EEEE');
    this.nextMonthFirstName = format(this.firstDayOfNextMonth, 'EEEE');

    this.todayDayIndex = getDate(this.todayDate);
    this.todayMonth = format(this.todayDate, 'MMMM'); // mese in formato stringa (inglese) es: May
    this.todayYear = getYear(this.todayDate);

    this.daysInMonth = getDaysInMonth(this.todayDate)
    this.daysInPrecMonth = getDaysInMonth(subMonths(this.todayDate, 1));
    this.daysInNextMonth = getDaysInMonth(addMonths(this.todayDate, 1));

    this.selectedDay = this.todayDayIndex;
    this.selectedMonth = this.todayMonthDay;
    this.selectedYear = this.todayYear;

    this.getGiornoScelto.setValue(this.selectedDay.toString());

    this.refreshData();

    this.appuntamento = JSON.parse(localStorage.getItem('app') || '{}');

    if (this.appuntamento && this.appuntamento.idServizioErogato) {
      if (this.appuntamento.servizio?.id != undefined) {
        if ((this.appuntamento.operatore as Employee).id != null || undefined) {
          this.subs.sink = this.prenotazioneService.getOperatore((this.appuntamento.operatore as Employee).id).subscribe({
            next: (emp) => this.datiDipendente = emp,
            error: () => this.route.navigate(['error'])
          })
          this.idDipendente = <number>(this.appuntamento.operatore as Employee).id
        }
        if (this.appuntamento.dataApp != undefined && this.appuntamento.oraInizio != undefined && this.appuntamento.oraFine != undefined) {

          const conv: Date = zonedTimeToUtc(new Date(this.appuntamento.dataApp), 'Europe/Rome')

          this.selectedDay = getDate(conv);
          this.selectedMonth = getMonth(conv);
          this.selectedYear = getYear(conv)

          this.todayDate = setMonth(this.todayDate, conv.getMonth());
          this.todayDate = setYear(this.todayDate, conv.getFullYear());

          this.getGiornoScelto.setValue(this.selectedDay.toString());
          if (this.getOrarioInizioScelto.enabled) {
            this.selectedTime = this.appuntamento.oraInizio;
            this.getOrarioInizioScelto.setValue(this.appuntamento.oraInizio);
            this.getOrarioFineScelto.setValue(this.appuntamento.oraFine);
          }
          this.refreshData();
        }

        this.aggiornaListaOrari();
      }
      this.aggiornaIndisponibilitaMensile();
      this.circleLoading = false;
    } else {
      //void this.route.navigate(['error']);
    }

    this.subs.sink = this.translateService.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
      this.selectedLanguage = langChangeEvent.lang
    });
  }

  aggiornaIndisponibilitaMensile(): void {
    this.calendarLoading = true;
    if (isEqual(this.todayDate, this.actualDate)) {
      this.subs.sink = this.prenotazioneService.indisponibilitaMensili(<string>this.appuntamento?.idServizioErogato, this.todayDate, <number>(this.appuntamento?.operatore as Employee).id).subscribe({
        next: (fest) => {
          this.listaFestivita = fest
        },
        complete: () => this.calendarLoading = false,
        error: () => this.calendarLoading = false
      })
    } else {
      this.subs.sink = this.prenotazioneService.indisponibilitaMensili(<string>this.appuntamento?.idServizioErogato, setDate(this.todayDate, 1), <number>(this.appuntamento?.operatore as Employee).id).subscribe({
        next: (fest) => {
          this.listaFestivita = fest
        },
        complete: () => this.calendarLoading = false,
        error: () => this.calendarLoading = false
      })
    }
  }

  monthDays(daysInMonth: number): any[] {
    this.refreshData();
    return new Array(daysInMonth);
  }

  precedentMonth(): void {
    if (!isBefore(subMonths(this.todayDate, 1), this.actualDate)) {
      this.todayDate = subMonths(this.todayDate, 1);
      this.refreshData();
    }
    this.aggiornaIndisponibilitaMensile();
  }

  nextMonth(): void {
    if (!isAfter(this.todayDate, addYears(this.actualDate, 1))) {
      this.todayDate = addMonths(this.todayDate, 1);
      this.refreshData();
    }
    this.aggiornaIndisponibilitaMensile();
  }

  fillPrecEmptyDays(referenceDay: string): any[] {
    switch (referenceDay) {
      case "Monday":
        return new Array(0);
      case "Tuesday":
        return new Array(1);
      case "Wednesday":
        return new Array(2);
      case "Thursday":
        return new Array(3);
      case "Friday":
        return new Array(4);
      case "Saturday":
        return new Array(5);
      case "Sunday":
        return new Array(6);
      default:
        return new Array(0);
    }
  }

  lengthPrecMonthDays(referenceDay: string): number {
    return this.fillPrecEmptyDays(referenceDay).length;
  }

  fillNextEmptyDays(calendarTuples: number, firstDayofMonth: string): any[] {
    const calendarBtnCount = calendarTuples - this.lengthPrecMonthDays(firstDayofMonth) - this.daysInMonth;
    return new Array(calendarBtnCount);
  }

  refreshData(): void {
    this.todayYear = getYear(this.todayDate);
    this.todayMonth = format(this.todayDate, 'MMMM');
    this.todayMonthDay = getMonth(this.todayDate);

    this.firstDayOfMonth = startOfMonth(this.todayDate);
    this.weekdayName = format(this.firstDayOfMonth, 'EEEE');

    this.daysInMonth = getDaysInMonth(this.todayDate)
    this.daysInPrecMonth = getDaysInMonth(subMonths(this.todayDate, 1));
    this.daysInNextMonth = getDaysInMonth(addMonths(this.todayDate, 1));

    this.disablePrecedent = isBefore(subMonths(this.todayDate, 1), this.actualDate);
    this.disableNext = isAfter(this.todayDate, addMonths(this.actualDate, 11));
  }


  aggiornaListaOrari(): void {
    this.skeletonLoading = true;

    let conv: Date = zonedTimeToUtc(new Date(this.todayDate), 'Europe/Rome')
    conv = setDate(conv, this.selectedDay);
    conv = setMonth(conv, this.selectedMonth);
    conv = setYear(conv, this.selectedYear);

    if (this.appuntamento?.flScelto) {
      this.subs.sink = this.prenotazioneService.getSlotOrari(<string>this.appuntamento.idServizioErogato, conv, this.idDipendente).subscribe({
        next: (value) => this.fasceOrarie = value,
        complete: () => this.skeletonLoading = false
      });
    } else {
      this.subs.sink = this.prenotazioneService.getSlotOrari(<string>this.appuntamento?.idServizioErogato, conv).subscribe({
        next: (value) => this.fasceOrarie = value,
        complete: () => this.skeletonLoading = false
      });
    }
  }

  onClickDay(day: number): void {
    this.selectedTime = "";
    this.selectedDay = day;

    this.selectedMonth = this.todayMonthDay;
    this.selectedYear = this.todayYear;

    this.getOrarioInizioScelto.setValue('');
    this.getOrarioFineScelto.setValue('');
    this.getGiornoScelto.setValue(day.toString());

    this.refreshData();
    this.aggiornaListaOrari();
  }

  onClickTime(orarioInzio: string | undefined | null, orarioFine: string | undefined | null, listaIdDipendenti: number[] | undefined | null): void {
    if (orarioInzio && orarioFine && listaIdDipendenti !== undefined) {
      if (this.appuntamento?.flScelto) {
        localStorage.setItem('app_op', JSON.stringify(listaIdDipendenti));
      }

      this.selectedTime = orarioInzio;
      this.getOrarioInizioScelto.setValue(orarioInzio);
      this.getOrarioFineScelto.setValue(orarioFine);
    }
  }

  goToSceltaServiziPrenotazione(): void {
    this.setAppStorage();
    if(this.codiceServizio){
      void this.route.navigateByUrl('Appuntamenti/scelta-servizi-prenotazione?servizio=' + this.codiceServizio + "&ufficio=" + <string>this.ufficio, {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
    }else{
      void this.route.navigate(['Appuntamenti/scelta-servizi-prenotazione'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
    }
  }

  goToSceltaRiepilogoPrenotazione(): void {
    this.setAppStorage();
    if(this.codiceServizio){
      void this.route.navigateByUrl('Appuntamenti/riepilogo-prenotazione?servizio=' + this.codiceServizio + "&ufficio=" + <string>this.ufficio, {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
    }else{
      void this.route.navigate(['Appuntamenti/riepilogo-prenotazione'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
    }
  }

  goToHome():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkHome;
  }

  setAppStorage(): void{
    if (this.formSceltaOrario.valid && this.getGiornoScelto.value !== undefined && this.getOrarioInizioScelto.value !== undefined && this.getOrarioFineScelto.value !== undefined) {
      this.selectedDate = setMonth(this.selectedDate, this.selectedMonth);
      this.selectedDate = setYear(this.selectedDate, this.selectedYear);
      this.selectedDate = setDate(this.selectedDate, this.selectedDay);

      this.appuntamento!.dataApp = zonedTimeToUtc(this.selectedDate, 'Europe/Rome');

      this.appuntamento!.oraInizio = this.getOrarioInizioScelto.value;
      this.appuntamento!.oraFine = this.getOrarioFineScelto.value;

      localStorage.setItem('app', JSON.stringify(this.appuntamento));
    }
  }

  onTour(): any {
    this.joyrideService.startTour({
      steps: ['primoStep', 'secondoStep', 'terzoStep']
    })
  }

  goToListaPrenotazioni():void{
    return void this.route.navigate(['Appuntamenti/lista-prenotazioni']).then();
  }

  checkListaPrenotazioni():boolean{
    return <boolean>window.history.state.isListaPrenotazioni;
  }

  goToNuovoAppuntamento():void{
    if(this.codiceServizio){
      void this.route.navigateByUrl('Appuntamenti/prenota-nuovo-appuntamento?servizio=' + this.codiceServizio + "&ufficio=" + <string>this.ufficio, {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}});
    }else{
      void this.route.navigate(['Appuntamenti/prenota-nuovo-appuntamento'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}});
    }
  }

  goToInserimentoDatiPrenotazione(): void {
    if(this.codiceServizio){
      void this.route.navigateByUrl('Appuntamenti/inserimento-dati-prenotazione?servizio=' + this.codiceServizio + "&ufficio=" + <string>this.ufficio, {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
    }else{
      void this.route.navigate(['Appuntamenti/inserimento-dati-prenotazione'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
    }
  }
}
